import React from 'react';

import { ButtonProps } from '@/components/shadcn/ui/button';
import { ConnectedBtcWallet } from '@/networks/btc-like/btc';

const HeaderWalletDrawerBtcWalletConnect: React.FC<ButtonProps> = (props) => {
  return <ConnectedBtcWallet {...props} />;
};

export default HeaderWalletDrawerBtcWalletConnect;
